<script lang="ts">
  import { Loader } from "lucide-svelte"
  import { signupStore } from "$app/signupstore.svelte"
  import { type Snippet } from "svelte"

  let { title }: { title?: Snippet } = $props()

  let cardTokenInput = $state<HTMLInputElement | null>(null)
  let cardErrors = $state<HTMLElement>(null)

  let stripe: any = {}
  let cardElement: any = {}

  function loadStripeElements() {
    // Time for Stripe.js to do its magic.
    // @ts-ignore
    stripe = Stripe(signupStore.stripe_publish_key)
    let elements = stripe.elements()

    let style = {
      base: {
        fontSize: "16px",
        color: "#32325d",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
        fontSmoothing: "antialiased",
        "::placeholder": {
          color: "#a0aec0"
        }
      }
    }

    cardElement = elements.create("card", { style: style })
    cardElement.mount("#card-element")
    cardElement.on("change", clearCardError)
  }

  const clearCardError = () => {
    cardErrors.classList.add("hidden")
  }

  export async function getStripeToken(): Promise<string> {
    let result: any = { token: { id: "" } }
    result = await stripe.createToken(cardElement)

    if (result.error) {
      cardErrors.classList.remove("hidden")
      cardErrors.textContent = result.error.message
      return ""
    }

    return result.token.id
  }
</script>

<svelte:head>
  <script src="https://js.stripe.com/v3/" onload={loadStripeElements}></script>
</svelte:head>

<div class="pb-2">
  {#if title}
    {@render title()}
  {/if}

  <div bind:this={cardErrors} role="alert"></div>
  <label for="first_name" class="block text-sm font-medium text-gray-700">
    Credit Card
  </label>
  <div
    class="mt-1 p-2 border shadow-sm min-h-10 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md bg-white"
  >
    <div id="card-element">
      <span class="text-gray-400 flex items-center gap-1">
        <Loader class="size-5 animate-spin" />
        Loading card component...
      </span>
    </div>
    <input type="hidden" bind:this={cardTokenInput} />
  </div>
</div>
